export default "__VITE_ASSET__B08S4mMM__"